<mat-toolbar color="accent">Submit MOH Treatment Claim</mat-toolbar>

<div *ngrxLet="treatmentData$ as treatmentData" class="flex flex-col gap-4 p-4">
  <form class="flex flex-col gap-4" [formGroup]="form">
    @if (treatmentData.showRequiresApproval) {
      <div class="flex flex-col gap-4">
        <pr-information-box>
          The selected MOH schedule requires prior approval. Please select from
          an approved Prior Approval Request or manually enter an approval
          number.
        </pr-information-box>

        <div class="flex gap-2">
          <mat-form-field class="flex-1" subscriptSizing="dynamic">
            <mat-label>Prior Approval Requests</mat-label>
            <mat-select formControlName="approvalRequest">
              @for (request of data.approvalRequests; track request.ref.path) {
                <mat-option [value]="request">
                  {{ request | map: getApprovalRequestLabel }}
                </mat-option>
              }
            </mat-select>
          </mat-form-field>

          <mat-form-field class="flex-1" subscriptSizing="dynamic">
            <mat-label>Prior Approval Number</mat-label>
            <input matInput formControlName="approvalNumber" />
          </mat-form-field>
        </div>
      </div>
    }

    <div class="flex gap-2">
      <mat-form-field class="flex-1" subscriptSizing="dynamic">
        <mat-label>MOH Schedule</mat-label>
        <mat-select formControlName="claimType">
          @for (option of claimTypes; track option) {
            <mat-option
              [value]="option"
              [disabled]="option | map: claimTypeDisabled : this"
            >
              {{ option | map: getClaimTypeLabel }}
            </mat-option>
          }
        </mat-select>
      </mat-form-field>
      <mat-checkbox
        class="flex-1"
        formControlName="isAnnualConsultation"
        [disabled]="form.controls.claimType.value !== 'ohsa'"
      >
        Is Annual Consultation?
      </mat-checkbox>
    </div>

    <div class="flex gap-2">
      <mat-form-field class="flex-1" subscriptSizing="dynamic">
        <mat-label>School Attended</mat-label>
        <input
          placeholder="Search schools..."
          matInput
          formControlName="school"
          [required]="true"
          [matAutocomplete]="schoolAuto"
        />
        <mat-autocomplete
          #schoolAuto="matAutocomplete"
          [displayWith]="displayFn"
        >
          @for (
            school of schoolSearch.results$ | async;
            track school.schoolNumber
          ) {
            <mat-option [value]="school">
              {{ school.schoolName }}
            </mat-option>
          }
        </mat-autocomplete>
      </mat-form-field>

      <mat-form-field class="flex-1" subscriptSizing="dynamic">
        <mat-label>Patient NHI Number</mat-label>
        <input matInput formControlName="nhiNumber" />
      </mat-form-field>
    </div>

    <pr-moh-agreement-holder-form
      [form]="agreementHolderForm"
      [practice]="data.practice"
      [practitioner]="data.practitioner"
    />
  </form>

  @if (isSdsClaimType$ | async) {
    <pr-moh-sds-claim-form [form]="sdsForm" />
  }

  <div class="flex flex-col gap-2">
    @if (treatmentData.showStandardPackage) {
      <pr-moh-treatment-list-card
        title="OHSA Standard Package"
        [codes]="treatmentData.standardPackage"
      />
    }

    @if (treatmentData.showAdditionalTreatment) {
      <pr-moh-treatment-list-card
        title="Additional Treatment"
        [codes]="treatmentData.additionalTreatment"
        [enableComments]="true"
        (commentChange)="updateComment($event.comment, $event.uid)"
      />
    }

    @if (treatmentData.showRequiresApproval) {
      <pr-moh-treatment-list-card
        title="Additional Treatment Requiring Prior Approval"
        [codes]="treatmentData.requiresApproval"
        [enableComments]="true"
      />
    }
  </div>

  <pt-buttons-container>
    <pt-loader-button
      type="flat"
      color="primary"
      [loading]="loading()"
      [disabled]="loading() || form.invalid"
      (click)="submit()"
    >
      Generate Forms
    </pt-loader-button>
  </pt-buttons-container>
</div>
